import React from "react";
import Select from "react-select";
import { useSelector } from "react-redux";

import { colors } from "../../../css components/Style";

export default function SortBy({ sortBy, setSortBy, categorize }) {
  const { siteColors } = useSelector((state) => state.renderUIDetails);

  let options = [
    { value: "ALL", label: "All" },
    { value: "ACTIVE", label: "Active", color: colors.green },
    { value: "OFFER_ACCEPTED", label: "Accepted", color: siteColors?.primary },
    { value: "CREATED", label: "Created", color: colors.blue },
    { value: "REQUESTED", label: "Requested", color: colors.yellow },
  ];

  if (categorize === "Campaign Offers") {
    options = [
      { value: "ALL", label: "All" },
      { value: "ACTIVE", label: "Active", color: colors.green },
      {
        value: "OFFER_ACCEPTED",
        label: "Accepted",
        color: siteColors?.primary,
      },
      { value: "CREATED", label: "Created", color: colors.blue },
      { value: "REQUESTED", label: "Requested", color: colors.yellow },
      { value: "EXPIRED", label: "Expired", color: colors.error },
    ];
  }

  if (categorize === "Active Campaigns") {
    options = [
      { value: "ACTIVE", label: "Active", color: colors.green },
      { value: "DEACTIVATED", label: "Deactivated", color: colors.yellow },
      { value: "EXPIRED", label: "Expired", color: colors.error },
    ];
  }

  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      height: "50px",
      p: "15px 18px",
      color: "#000000",
      fontWeight: 400,
      display: "flex",
      width: "150px",
      maxWidth: "237px",
      fontsize: "14px",
      lineHeight: "20px",
      alignItems: "center",
      borderRadius: "30px",
      justifyContent: "space-between",
      boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: " #000000",
    }),
    singleValue: (styles, { data }) => ({
      ...styles,
      fontWeight: 600,
      fontSize: "18px",
      color: data.color,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        color: data.color,
        fontWeight: isSelected ? 600 : 400,
        backgroundColor: "white",
        fontSize: "18px",
        lineHeight: "20px",
        mixBlendMode: "normal",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
  };

  const handleTypeSelect = (e) => {
    setSortBy(e.value);
  };

  return (
    <Select
      styles={style}
      options={options}
      onChange={handleTypeSelect}
      isSearchable={false}
      placeholder="Campaign Status"
      components={{
        IndicatorSeparator: () => null,
      }}
      value={options.filter(function (option) {
        return option.value === sortBy;
      })}
    />
  );
}
